// extracted by mini-css-extract-plugin
export default {"BackDrop":"BackDrop_BackDrop__pCoXv"};